<script setup lang="ts">
useSeoMeta({
  title: 'Okgym - Fitcentrum | Pardubický Kraj',
  description:
    'Fitness, Gym, Solarium, Box - Lepší nabídku nenajdeš! Pro studenty zvýhodněná nabídka jen v Okgym',
});
</script>

<template>
  <PageContainer no-alignment no-padding>
    <IndexHeader />
    <ServicesRelaxContainer />
    <ServicesExerciseContainer />
    <Feed />
    <IndexGallery />
  </PageContainer>
</template>
